module.exports = __webpack_public_path__ + "img/C05TechAuxiliaCamp_Upgrade3_ua.1b581680.webp";